<template>
    <IndexBase @auth="onAuth($event)" action="Index" controller="BaDelay"></IndexBase>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{ mode }}] BA Delay
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                style="width: 550px" :breakpoints="{ '960px': '80vw' }">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{ this.$formatDateTime(header.Created_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Created_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{ this.$formatDateTime(header.Edited_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Edited_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Deleted_Date">
                                    <div class="row">
                                        <i class="pi pi-trash" /> {{ this.$formatDateTime(header.Deleted_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Deleted_By }}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <Button icon="pi pi-save" label="Draft" class="p-button-secondary mr-2" @click="confirmDraft($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && (header && header.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL && header.Status != this.$APPROVAL_STATUS.APPROVED && header.Status != this.$APPROVAL_STATUS.REVISED && header.Status != this.$APPROVAL_STATUS.DONE)"/>
                        <Button icon="pi pi-upload" label="Save" class="p-button-success" @click="confirm($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && !onlyDraft" />
                        <Button icon="pi pi-trash" label="Delete" class="p-button-danger" @click="confirm($event)"
                            v-if="mode == this.$FORM_MODE_DELETE" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-6">

                            <FormField :labelName="$t('doc_no')" fieldName="Doc_No" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Doc_No" v-model="header.Doc_No" required="true" type="text"
                                    :placeholder="$t('doc_no')" v-if="header" 
                                    :disabled="true" />
                            </FormField>

                            <FormField :labelName="$t('doc_date')" fieldName="Hari_Tanggal" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <DatePicker name="day_date" v-model="header.Hari_Tanggal" type="text"
                                :placeholder="$t('doc_date')" v-if="header" dateFormat="dd/mm/yyyy"
                                inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                <small
                                    v-if="header && !header.Hari_Tanggal && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('doc_date')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('company_contractor')" fieldName="Contractor_Code" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <CustomSelect name="Contractor_Code" :filter="true"  v-if="header"
                                    v-model="header.Contractor_Code" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/contractor_code'"
                                    :minLength="0"
                                    :params="{ docDate: (this.header.Hari_Tanggal != null ? this.header.Hari_Tanggal  : null)}"  
                                    :disabled="true"/>
                                    <small v-if="header && !header.Contractor_Code && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('company_contractor')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('job_desc')" fieldName="Deskripsi_Pekerjaan" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Deskripsi_Pekerjaan" v-model="header.Deskripsi_Pekerjaan" required="true" type="text"
                                    :placeholder="$t('job_desc')" v-if="header"
                                    :disabled="true" />
                                    <small v-if="header && !header.Deskripsi_Pekerjaan && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('job_desc')) }}
                                    </small>
                            </FormField>

                            <FormField :labelName="$t('no_spo')" fieldName="No_SPO" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && header.No_SPO != null">
                                <InputText name="No_SPO" v-model="header.No_SPO" required="true" type="text"
                                    :placeholder="$t('no_spo')" v-if="header"
                                    :disabled="true" />
                                    <small v-if="header && !header.No_SPO && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('no_spo')) }}
                                     </small>
                            </FormField>
                            
                            <FormField :labelName="$t('end_date')" fieldName="Tanggal_Selesai" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <DatePicker name="end_date" v-model="header.Tanggal_Selesai" type="text"
                                :placeholder="$t('end_date')" v-if="header" dateFormat="dd/mm/yyyy"
                                inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                :disabled="true"/>
                                <small
                                    v-if="header && !header.Tanggal_Selesai && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('day_date')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('final_date')" fieldName="Tanggal_Final" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <DatePicker name="final_date" v-model="header.Tanggal_Final" type="text"
                                :placeholder="$t('final_date')" v-if="header" dateFormat="dd/mm/yyyy"
                                inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                <small
                                    v-if="header && !header.Tanggal_Final && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('final_date')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('count_delay_day')" fieldName="Jumlah_Hari_Keterlambatan" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Nilai_Kontrak" v-model="this.DayOfDelay" required="true" type="text"
                                    :placeholder="$t('count_delay_day')" v-if="header"
                                    :disabled="true" :useGrouping="false"/>
                                    <small v-if="header && !this.DayOfDelay && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('count_delay_day')) }}
                                    </small>
                            </FormField>

                            <FormField :labelName="$t('result')" fieldName="Result" v-model="header" labelClass="col-4" fieldClass="col-6">
                              
                                <div class="flex flex-wrap gap-3">
                                    <div class="flex align-items-center">
                                        <RadioButton v-model="header.Result" name="Result" value="Penalty" v-if="header" :disabled="true" />
                                        <label for="Result" class="ml-2 mr-2">Penalty</label>
                                    </div>
                                    <div class="flex align-items-center">
                                        <RadioButton v-model="header.Result" name="Result" value="No Penalty"  v-if="header" :disabled="true" />
                                        <label for="Result" class="ml-2">No Penalty</label>
                                    </div>
                                </div>

                                    <small v-if="header && !header.Result && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('result')) }}
                                    </small>
                            </FormField>

  
                            
                        </div>  
                        <div class="col-6">
                            
                            <FormField :labelName="$t('status')" fieldName="Status" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Status" v-model="header.Status" required="true" type="text"
                                    :placeholder="$t('status')" v-if="header"
                                    :disabled="true" />
                            </FormField>

                            <FormField :labelName="$t('count_day_penalty')" fieldName="Jumlah_Hari_Penalty" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Jumlah_Hari_Penalty" v-model="header.Jumlah_Hari_Penalty" required="true" type="text"
                                    :placeholder="$t('count_day_penalty')" v-if="header"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" :useGrouping="false" :min="0" @input="onChangeDayPenalty"/>
                                    <small v-if="header && (header.Jumlah_Hari_Penalty == null) && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('count_day')) }}
                                    </small>
                            </FormField>


                            <FormField :labelName="$t('count_day')" fieldName="Jumlah_Hari" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Nilai_Kontrak" v-model="this.Number_of_Days" required="true" type="text" :min="0"
                                    :placeholder="$t('count_day')" v-if="header"
                                    :disabled="true" :useGrouping="false"/>
                                    <small v-if="header && (this.Number_of_Days == null) && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('count_day')) }}
                                    </small>
                            </FormField>


                            <FormField :labelName="$t(labelAppr1)" fieldName="Username_Site_Manager" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr1">
                                <CustomSelect name="Username_Site_Manager" :filter="true"  v-if="header"
                                    v-model="header.Username_Site_Manager" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion : header.Appr_As1,user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.DELAY, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_Site_Manager && submitted2 && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr1)) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t(labelAppr2)" fieldName="Username_PM_PIC_Contractor" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr2">
                                <CustomSelect name="Username_PM_PIC_Contractor" :filter="true"  v-if="header"
                                    v-model="header.Username_PM_PIC_Contractor" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion : header.Appr_As2,user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.DELAY, companycode: header.Company_Code,contractorcode : header.Contractor_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_PM_PIC_Contractor && submitted2 && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr2)) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t(labelAppr3)" fieldName="Username_PM_PIC_Company" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr3">
                                <CustomSelect name="Username_PM_PIC_Company" :filter="true"  v-if="header"
                                    v-model="header.Username_PM_PIC_Company" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion:header.Appr_As3, doc_type : this.$TypeDocument.DELAY, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_PM_PIC_Company && submitted2 && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr3)) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t(labelAppr4)" fieldName="Username_CP_PIC" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr4">
                                <CustomSelect name="Username_CP_PIC" :filter="true"  v-if="header"
                                    v-model="header.Username_CP_PIC" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion : header.Appr_As4,user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.DELAY, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_CP_PIC && submitted2 && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr4)) }}
                                </small>
                            </FormField>
                            
                            <FormField :labelName="$t('reason')" fieldName="Reason" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && (header.Status == this.$APPROVAL_STATUS.DONE || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL)">
                                <InputText name="Reason" v-model="header.Reason" required="true" type="text"
                                    :placeholder="$t('reason')" v-if="header"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT|| header.Status != this.$APPROVAL_STATUS.DONE"/>
                                    <small v-if="header &&((!header.Reason && header.Status == this.$APPROVAL_STATUS.DONE)) && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('reason')) }}
                                    </small>
                            </FormField>

                        </div>
                        <div class="col-12">
                            <DataTable v-if="header" :loading="!header" :value="header.Details ? header.Details : null"
                                responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                                <Column :exportable="false" style="width:30px">
                                    <template #header>
                                        <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm"
                                            @click="addDetail()"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                    </template>
                                    <template #body="slotProps">
                                        <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                            @click="deleteDetail(slotProps)"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                            v-show="slotProps.data.mode != 'Delete'" />
                                    </template>
                                </Column>
                                <Column field="Description" :header="$t('description')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputText 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('description')" @change="onCellEditComplete(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                        </div>
                                    </template>
                                </Column>

                                
                                <Column field="Tanggal_Mulai" :header="$t('start_date')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <DatePicker name="Tanggal_Mulai" v-model="slotProps.data[slotProps.column.props.field]"
                                            :placeholder="$t('start_date')" @date-select="onCellEditComplete(slotProps);" @change="onCellEditComplete(slotProps);"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                            v-show="slotProps.data.mode != 'Delete'"/>
                                            <!-- onSelectDate1($event,slotProps.data) -->
                                        </div>
                                    </template>
                                </Column>
                                
                                <Column field="Tanggal_Selesai" :header="$t('date_end')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <DatePicker name="date_end" v-model="slotProps.data[slotProps.column.props.field]"
                                            :placeholder="$t('date_end')" @date-select="onCellEditComplete(slotProps);" @change="onCellEditComplete(slotProps);"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                            v-show="slotProps.data.mode != 'Delete'"/>
                                        </div>
                                    </template>
                                </Column>

                                <Column field="Hari" :header="$t('day')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputNumber
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('day')" @change="onCellEditComplete(slotProps)"
                                                :disabled="true"
                                                v-show="slotProps.data.mode != 'Delete'" :useGrouping="false"/>

                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                      
                        <div class="col-12 mt-4" v-if="this.mode != this.$FORM_MODE_CREATE">
                            <TabView>
                                <TabPanel :header="$t('log_history')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.dataModelReqLogs"
                                        :dataRequestLog="this.dataRequestLogs" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('release_approval')">
                                    <ChangeHistory angeHistory v-if="this.header" :modelValue="this.dataModelRelease"
                                        :dataRequestLog="this.dataRelease" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('Change_History')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.detailLog" :dataRequestLog="this.dataChangesLog" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                            </TabView>
                        </div>
                    </div>
                </div>
            </template>
        </Card>
    </form>
</template>


<script>
import IndexBase from '../Helper/IndexBase.vue'
export default {
    name: "Editor",
    components: {
        IndexBase
    },
    data() {
        return {
            indexName: "BaDelayIndex",
            url: this.$API_URL + "badelay/",
            header: null,
            detail: null,
            mode: "",
            submitted: false,
            id: 0,
            mainid : 0,
            formEditable: true,
            dataModelReqLogs: [],
            dataRequestLogs: [
                { field: "Action_Role", header: "Role" },
                { field: "Action_By", header: "Action By" },
                { field: "Action", header: "Action" },
                { field: "Action_Date", header: "Action Date" },
                { field: "Notes", header: "Notes" },
            ],
            dataModelRelease: [],
            dataRelease: this.$dataRelease,
            viewFiles : null,
            detailLog : null,
            dataChangesLog:this.$dataChangesLog,
            labelAppr1 : "",
            labelAppr2 : "",
            labelAppr3 : "",
            labelAppr4 : "",
            submitted2 : false,
            onlyDraft: false,
        }
    },
    methods: {
        onAuth(event) {
            this.onlyDraft = event.onlyDraft;
        },
        onSelectDate1(e,data){
            if(this.header.Tanggal_Final != null && this.header.Tanggal_Selesai !=null){
                var date1 = new Date(e);
                var date2 = new Date(this.header.Tanggal_Selesai);
                var date3 = new Date(this.header.Tanggal_Final);
                

                if(this.$isNotWIB){    
                    date1.setHours(0, 0, 0, 0);
                    date2.setHours(0, 0, 0, 0);
                    date3.setHours(0, 0, 0, 0);
                }

                var cekDate = date1 >= date2 &&  date1 <= date3;
                
                if(!cekDate){
                    this.showError("Error", 'Date of out range from Tanggal selesai SPO/SPK and Tanggal Final Inspeksi QC');
                    data.Tanggal_Mulai = null;
                }
            }
        },
        onSelectDate2(e,data){
            
            if(this.header.Tanggal_Final != null && this.header.Tanggal_Selesai !=null){

                var date1 = new Date(e);
                var date2 = new Date(this.header.Tanggal_Selesai);
                var date3 = new Date(this.header.Tanggal_Final);
                

                if(this.$isNotWIB){    
                    date1.setHours(0, 0, 0, 0);
                    date2.setHours(0, 0, 0, 0);
                    date3.setHours(0, 0, 0, 0);
                }

                var cekDate = date1 >= date2 &&  date1 <= date3;
                if(!cekDate){
                    this.showError("Error", 'Date of out range from Tanggal selesai SPO/SPK and Tanggal Final Inspeksi QC');
                    data.Tanggal_Selesai = null;
                }
            }
        },
        onChangeDayPenalty(){
            if(this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT)
            {
                if(this.header.Jumlah_Hari_Penalty > 0)
                {
                    this.header.Result = "Penalty";
                }else{
                    this.header.Result = "No Penalty";
                }
            }

        },  
        getData() {
            var self = this;
            this.$axios.get(this.url + this.mainid + "/" +this.id + "/" + this.mode)
                .then((response) => {

                    if(!response.data.success){
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: this.$DEFAULT_TIMER });   
                        return;
                    }

                    self.header = response.data.data.header;
                    self.header.mode = self.mode;
                    self.detail = response.data.data.detail;
                    self.dataModelReqLogs = response.data.data.header.request_log;
                    self.dataModelRelease = response.data.data.header.approval_log;
                    self.detailLog = self.header.DetailLog;

                    var listAppr = response.data.data.listPicAppr;
                    if(listAppr.length > 0)
                    {
                        listAppr.forEach(a=>{
                            if(a.Sign_Position == 1){
                                self.labelAppr1 = a.Approval_As;
                                self.header.Appr_As1 = a.Approval_As;
                                self.header.Sign_Position1 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 2){
                                self.labelAppr2 = a.Approval_As;
                                self.header.Appr_As2 = a.Approval_As;
                                self.header.Sign_Position2 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 3){
                                self.labelAppr3 = a.Approval_As;
                                self.header.Appr_As3 = a.Approval_As;
                                self.header.Sign_Position3 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 4){
                                self.labelAppr4 = a.Approval_As;
                                self.header.Appr_As4 = a.Approval_As;
                                self.header.Sign_Position4 =  a.Sign_Position;
                            }
                        });
                    }

                    // Set radio button based on Jumlah_Hari_Penalty
                    self.onChangeDayPenalty();
                })
                .catch(function (error) {
                    self.showError("Error", error);
                });
        },
        saveData() {
            this.$emit('block-ui');
            var self = this;

            this.header.Jumlah_Hari_Keterlambatan = this.DayOfDelay;
            this.header.Jumlah_Hari = this.Number_of_Days;

            if(this.header){        
                this.header.Hari_Tanggal_String = this.$moment(this.header.Hari_Tanggal).format('YYYY/MM/DD').toString()
                this.header.Tanggal_Final_String = this.$moment(this.header.Tanggal_Final).format('YYYY/MM/DD').toString()
                this.header.Details.forEach(a=>{
                    if(a.Tanggal_Mulai){
                        var date = new Date(a.Tanggal_Mulai);
                        a.Tanggal_Mulai_String = this.$moment(date).format('YYYY/MM/DD').toString()
                    }
                    
                    if(a.Tanggal_Selesai){
                        var date = new Date(a.Tanggal_Selesai);
                        a.Tanggal_Selesai_String = this.$moment(date).format('YYYY/MM/DD').toString()
                    }

                });    
            }

             this.$axios.post(this.url, this.header)
                .then((response) => {
                    if (response.data.success) {
                        if (this.mode == this.$FORM_MODE_DELETE) {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Deleted', detail: "BA Delay has been deleted successfully", life: 3000 } });
                        } else {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "BA Delay has been saved successfully", life: 3000 } });
                        }

                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 3000 });
        },
        backToIndex() {
            if(this.$router.options.history.state.back != null)
                this.$router.push({ path: this.$router.options.history.state.back });
            else 
              this.$router.push({ path: "Index" });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        confirm(event) {
            this.submitted = true;
            this.submitted2 = true;
            var self = this;
            if(self.mode != this.$FORM_MODE_DELETE){

                //|| !this.header.Username_Site_Manager || !this.header.Username_PM_PIC_Company || !this.header.Username_PM_PIC_Contractor || !this.header.Username_CP_PIC
                if (!this.header.Hari_Tanggal || !this.header.Deskripsi_Pekerjaan || (this.header.isSpo &&!this.header.No_SPO) || !this.header.Tanggal_Final||
                    !this.header.Tanggal_Selesai || !this.DayOfDelay || (this.Number_of_Days == null) || !this.header.Result || 
                    (this.labelAppr1 && !this.header.Username_Site_Manager) || (this.labelAppr3 && !this.header.Username_PM_PIC_Company) || (this.labelAppr2 && !this.header.Username_PM_PIC_Contractor) || (this.labelAppr4 && !this.header.Username_CP_PIC)
                    ||(!this.header.Reason && this.header.Status == this.$APPROVAL_STATUS.DONE) || (this.header.Jumlah_Hari_Penalty == null)) {
                    return;
                }
                
            
                if(this.DayOfDelay < 0 ){
                    self.showError("Error", "Jumlah Hari Keterlambatan can't minus")
                    return;
                }
                
                if(this.DayOfDelay < this.Number_of_Days){
                    self.showError("Error", "Total Days of Delay < Total days of Delay Description")
                    return;
                }
                
                if(this.Number_of_Days <= 0 ){
                    self.showError("Error", "Cannot submit, number of days still 0")
                    return;
                }
                
              
                var Details = this.header.Details.filter(a=> a.mode != this.$FORM_MODE_DELETE && a.Description);
    
                if(Details.length == 0){
                    self.showError("Error", "Must have one detail")
                    return;
                }

            }
           

            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        confirmDraft(event) {
            this.submitted = true;
            this.submitted2 = false;
            var self = this;
            
            //!this.header.Username_Site_Manager || !this.header.Username_PM_PIC_Company || !this.header.Username_PM_PIC_Contractor || !this.header.Username_CP_PIC
            if (!this.header.Hari_Tanggal || !this.header.Deskripsi_Pekerjaan || (this.header.isSpo &&!this.header.No_SPO) || !this.header.Tanggal_Final||
                !this.header.Tanggal_Selesai || !this.DayOfDelay || (this.Number_of_Days == null) || !this.header.Result) {
                return;
            }
            
            if(this.DayOfDelay < 0 ){
                self.showError("Error", "Jumlah Hari Keterlambatan can't minus")
                return;
            }
            
            if(this.DayOfDelay < this.Number_of_Days){
                self.showError("Error", "Total Days of Delay < Total days of Delay Description")
                return;
            }

            // if(this.header.Details.length == 0){
            //     self.showError("Error", "Must have one detail")
            //     return;
            // }

            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure save as draft ?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if(this.mode == this.$FORM_MODE_CREATE)
                        this.header.mode = this.$FORM_MODE_DRAFT;
                    else if(this.mode == this.$FORM_MODE_EDIT)
                            this.header.mode = this.$FORM_MODE_DRAFT_EDIT;
                    else
                        this.header.mode = this.mode;
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        addDetail() {
            var newDetail = this.detail;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.Details.push(det);
        },
        deleteDetail(event) {
            if (event) {
                var detail = this.header.Details[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.Details.splice(this.header.Details.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditComplete(event) {
            this.editDetail(event.index);
        },
        editDetail(index) {
            if (this.header && this.header.Details) {
                let mode = this.header.Details[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Details[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        onFileRemove(files,data) {
                data.files_data = [];
                for(var i = 0; i<files.length;i++){
                    data.files_data.push(event.files[i]);
                }
        },
        onFileSelect(event, data) {
                data.files_data = [];
                for(var i = 0; i<event.files.length;i++){
                    data.files_data.push(event.files[i]);
                }
        },
        onFileSelectUpload(event) {
            this.detailFiles = event.files;
            this.uploadFile = true;
        },
        onDownloadFile(file){
            var self = this;
            this.$axios.get(this.url + "download_attachment/" + file.id + "/" + file.name, {
                responseType: 'blob',
                timeout: this.$AXIOS_TIMEOUT_LONG
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file.name);
                    document.body.appendChild(link);
                    link.click();
                    
                })
                .catch(function (err) {
                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                    self.blocked = false;
                    //self.showAssignModal = false;
                });
        },
    },
    computed:{
        DayOfDelay(){
            let result = 0;
            
            if(this.header.Tanggal_Final !=null){
                var endDate = new Date(this.header.Tanggal_Final);
                var startDate = new Date(this.header.Tanggal_Selesai);
                   
                if(this.$isNotWIB){    
                    endDate.setHours(0, 0, 0, 0);
                    startDate.setHours(0, 0, 0, 0);
                }

                const differenceMs = endDate - startDate;
                result = Math.floor(differenceMs / (1000 * 60 * 60 * 24))       
            }
            // if(this.header.Tanggal_Final == null && this.header.Tanggal_Selesai == null)
            //     result = 0;
                
            return result;
        },
        Number_of_Days(){
            var result = 0;
            var arrData = this.header.Details.filter(a=> a.mode != this.$FORM_MODE_DELETE);
            if(arrData.length != 0){

                arrData.forEach(a => {
                    var startDate = new Date(a.Tanggal_Mulai);
                    var endDate = new Date(a.Tanggal_Selesai);
                    
                    if(this.$isNotWIB){    
                        startDate.setHours(0, 0, 0, 0);
                        endDate.setHours(0, 0, 0, 0);
                    }
                  
                    // if(a.Tanggal_Selesai == null)
                    //     endDate = 0;
                        
                    var differenceMs = endDate - startDate;
                    var hasil = Math.floor(differenceMs / (1000 * 60 * 60 * 24));

                    a.Hari = hasil;

                    // if(a.Tanggal_Mulai == null && a.Tanggal_Selesai == null)
                    //     a.Hari = 0;
                    
                   
                    result+= hasil; 
                
                });
            }
           
            return result;
        }
    },
    watch: {
        'header.Jumlah_Hari_Penalty': function(newVal) {
            if (this.header) 
            {
                if(this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT)
                {
                    if (newVal > 0) {
                        this.header.Result = "Penalty";
                    } else {
                        this.header.Result = "No Penalty";
                    }
                }

            }
        }
    },
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;
        this.mainid = this.$route.query.mainid ?? 0;
        this.getData();
        if(this.$router.options.history.state.back != null){
            var indexName = this.$router.options.history.state.back.split("/");
            if(indexName[1] == "MainData")
                this.indexName = "MainDataIndex";
        }
    }
}
</script>